module.exports = ['$scope', '$q', 'constants', 'dateUtils', '$location', 'Survey', 'Utils', 'vskoModalService', 'Organisations',
  function ($scope, $q, constants, dateUtils, $location, Survey, Utils, vskoModalService, Organisations) { //eslint-disable-line
    'use strict'; //eslint-disable-line

    $scope.stepNumber = 1;
    $scope.$emit('wellbe_wizard_step', { stepNumber: $scope.stepNumber });

    $scope.headerTitle = 'Intake';
    $scope.headerDescription = 'We stellen je eerst enkele algemene vragen over het team.';

    $scope.questions = constants.intakeQuestions;

    $scope.qtiTemplatePath = 'S001-simple.xml';

    function isAnsweredYes(question) {
      return question.answer.length > 0 && question.answer[0].identifier === 'YES';
    }

    async function sendSurvey() {
      const existingSurvey = await Survey.getSurvey();
      const schoolYear = dateUtils.parse(dateUtils.getEndOfSchoolYear(dateUtils.getNow())).getFullYear();
      const ou = Survey.getSchool();

      const survey = existingSurvey || {
        key: Utils.getUUID(),
        school: { href: ou.href },
        location: Survey.getPhysicalLocation() ? { href: Survey.getPhysicalLocation().href } : null,
        level: ou.type,
        schoolyear: schoolYear
      }

      // save intake answers given by the user
      survey.intakeanswers = $scope.questions
        .filter(qst => qst.answer && qst.answer.length > 0)
        .map(qst => {
          return {
            key: Utils.getUUID(),
            question: { href: `/content/${qst.key}` },
            answer: qst.answer[0].identifier
          };
        });

      if ($scope.showAlertAdvice) {
        survey.motivation = '...';
      }

      // send survey resource to the api updated with the given intake answers
      Survey.saveSurvey(survey).then(async () => {
        const intakeanswers = $scope.questions
          .filter(qst => qst.answer && qst.answer.length > 0)
          .map(qst => {
            return {
              question: qst.text, // NOTE: possibly will change to qst.description
              answer: qst.answer[0].identifier === 'YES' ? 'JA' : 'NEE'
            };
          });

        Survey.sendDirectorsMail(intakeanswers, $scope.showAlertAdvice, Survey.getDirectors());

        const userSurveys = Survey.getCachedUserSurveys();
        const otherSchoolSurvey = userSurveys.find(s => s.school.href === survey.school.href);

        if (!otherSchoolSurvey) {
          // in case it's the first survey for the school we send a notification to the system admin (#17090)
          Survey.sendFirstSchoolSurveyMail(survey);
        }
      });
    }

    function getAdviceMessage(showAlertAdvice) {
      const ou = Survey.getSchool();
      const managers = Survey.getDirectors();
      const noManagersMessage = `${ou.displayMgmtTeam.substring(0, 1).toUpperCase() + ou.displayMgmtTeam.substring(1)} van ${ou.name} is niet geregistreerd bij Katholiek Onderwijs Vlaanderen. Hierdoor kunnen wij de resultaten van de intake niet sturen naar ${ou.displayMgmtTeam}. Neem hiervoor contact op met <a href="mailto:gegevensbeheer@katholiekonderwijs.vlaanderen">gegevensbeheer@katholiekonderwijs.vlaanderen</a>.`; 
      if (showAlertAdvice) {
        const coreMessage = `Op basis van uw antwoorden op de intake-vragen zijn wij van oordeel dat de WellBe-bevraging onvoldoende tegemoet komt aan de problemen die zich stellen binnen ${ou.displayOuType}. Daarom raden wij u aan om contact op te nemen met de preventieadviseur psychosociale aspecten.`;
        return `${coreMessage}<br/><br/>${managers.length > 0
          ? `We hebben deze boodschap, samen met de resultaten van de intake, verstuurd naar ${ou.displayMgmtTeam}: <ul>${managers.map(director => `<li>${director.firstName} ${director.lastName}${ou.type === 'GOVERNINGINSTITUTION' ? ` [${director.positions.join(', ')}]` : ''}</li>`).join('')}</ul>`
          : `${noManagersMessage}<br/><br/>`}Je kan in overleg (onder verantwoordelijkheid van ${ou.displayMgmtTeam}) beslissen om de tool WellBe toch te gebruiken mits de nodige verantwoording.`;
      }
      if (managers.length === 0) {
        return  `${noManagersMessage}<br/><br/>Ondertussen kan je toch verdergaan met het finaliseren van de welzijnsbevraging.`;
      }
      return `We hebben de resultaten van de intake via mail verstuurd naar ${ou.displayMgmtTeam}: <ul>${Survey.getDirectors().map(director => `<li>${director.firstName} ${director.lastName}${ou.type === 'GOVERNINGINSTITUTION' ? ` [${director.positions.join(', ')}]` : ''}</li>`).join('')}</ul> Je kan verdergaan met het finaliseren van de welzijnsbevraging.`;
    }

    console.log('Intake - selected school / directors:', Survey.getSchool(), Survey.getDirectors());

    /** scope functions */

    $scope.onNext = () => {
      console.log('Next screen:', $scope.questions);

      const countNotFilled = $scope.questions.filter(qst => !qst.answer || qst.answer.length === 0).length;

      if (countNotFilled > 0) {
        // show error message -> missing answers
        $scope.feedbackMessage = 'Niet alle intake-vragen zijn beantwoord.';
        return;
      }

      // compute given answers to see which kind of advice show to the user
      // rule: . >= 80% with YES or 'stop intake qst' with YES => alert advice
      //       . otherwise just normal advice
      const totalQuestions = $scope.questions.length;
      const countYesAnswers = $scope.questions.filter(qst => isAnsweredYes(qst)).length;
      const countStopIntakeAnswers = $scope.questions.filter(qst => isAnsweredYes(qst) && qst.stopIntake).length;

      $scope.showAlertAdvice = countStopIntakeAnswers > 0 || ((countYesAnswers * 100 / totalQuestions) >= 80);

      $scope.adviceMessage = getAdviceMessage($scope.showAlertAdvice);

      // intake advice popup is closed
      let modalInstance = null;
      $scope.onClose = () => {
        modalInstance.close();
        modalInstance.result.finally(() => {
          if ($scope.showAlertAdvice) {
          // if an alert message was shown to the user then he has to enter a motivation to continue
            $location.path('/motivation');
          } else {
            $location.path('/enddate');
          }
        });
      };

      console.log('Count yes answers:', countYesAnswers, countStopIntakeAnswers);

      // show intake advice popup
      modalInstance =vskoModalService.open({
        template: require('./intakeAdvice.html'),
        scope: $scope
      });

      sendSurvey();
    };

    // Nothing needs to happen on selecting yes/no on the intake questions
    $scope.onChoiceSelected = () => {};
  }];
